import React from 'react';
import Link from '../link';

interface ListSectionProps {
  title: string;
  text: string;
  link?: string;
  linkText?: string;
  children?: React.ReactNode;
}

const ListSection = ({ title, text, link, linkText, children }: ListSectionProps) => (
  <div data-wx-listsection="heading-inline product-grid">
    <div className="list-section-heading">
      <div data-wx-label="" className="m-b-half">
        {title}
      </div>
      <div className="h2 no-margin">{text}</div>
      {!!(link && linkText) && (
        <div className="m-t hidden-lt-lg">
          <Link to={link} data-am-link="" title={linkText}>
            {linkText}
          </Link>
        </div>
      )}
    </div>
    <div className="list-section-content">{children}</div>
    {!!(link && linkText) && (
      <div className="list-section-action hidden-lg">
        <Link to={link} data-am-link="" title={linkText}>
          {linkText}
        </Link>
      </div>
    )}
  </div>
);

export default ListSection;
